/**
 * @license
 * Copyright Tyler Technologies, Inc. 
 * License: Apache-2.0
 */
import { defineCustomElement } from '@tylertech/forge-core';
import { AppBarHelpButtonComponent } from './app-bar-help-button';
export * from './app-bar-help-button-adapter';
export * from './app-bar-help-button-constants';
export * from './app-bar-help-button-core';
export * from './app-bar-help-button';
export function defineAppBarHelpButtonComponent() {
    defineCustomElement(AppBarHelpButtonComponent);
}
